import React from 'react';
import {Link,useInRouterContext} from 'react-router-dom';
// Member routes navigate without restarting auth/data loading. Standalone
// read-only previews retain an ordinary link when no app router is mounted.
export default function MemberLink({to,children,...props}){
 const routed=useInRouterContext();
 return routed?<Link to={to} {...props}>{children}</Link>:<a href={to} {...props}>{children}</a>;
}
